<template>
    <div class="tickets">
        <ruth-header :tickets="false"></ruth-header>
        <div id="container" class="nobackgroundimg">
            <div id="content">
                <h1 class="ticketsheading">TICKETS</h1>
                <loader :display="displayLoading"></loader>
                <div class="ticketbox"><iframe id="ticketframe" width="100%" height="100%" style="display:none;"></iframe></div>
            </div>

            <social-media></social-media>
            <ruth-footer></ruth-footer>
            <ruth-overlay></ruth-overlay>
        </div>
    </div>
</template>

<script>
    import '../bower_components/jquery/dist/jquery'

    import ruthHeader from './GlobalSegments/Header'
    import socialMedia from './GlobalSegments/SocialMedia'
    import ruthFooter from './GlobalSegments/Footer'
    import ruthOverlay from './GlobalSegments/Overlay'
    import loader from './GlobalSegments/Loader'

    let css = `<style type='text/css'>
* {
    font-family: 'Roboto Condensed', sans-serif;
}
span,p,td,form,th,label,h1 {
    color: white;
}

span, p, td, form, th, label {
    font-size:23px;
}

i {
    font-size:19px;
}

a, a:hover, a:active, a:visited { color: white; text-decoration:underline; }

table thead {
    border-bottom: 1px solid #f3dba8;
}

table tbody>tr.underlined {
    border-bottom: 1px solid #f3dba8;
}

#homeheading {
    text-align:center;
}

#homeheading span {
    font-weight:300;
    text-transform:uppercase;
    font-size:26px;
    letter-spacing: 0.1em;
}

.minusButton, .plusButton {
    content: ' ';
    display: inline-block;
    width: 21px !important;
    height: 23px !important;
    background-color: transparent !important;
    border: none !important;
    background-size: contain !important;
    background-position-y: 1px !important;
    background-repeat: no-repeat !important;
}

.minusButton {
    background:url('https://www.ruth-musical.org/static/ticket_img/buttons/Enabled-Minus.png');
}

.minusButton:disabled {
    background:url('https://www.ruth-musical.org/static/ticket_img/buttons/Disabled-Minus.png');
}

.minusButton:active {
    background:url('https://www.ruth-musical.org/static/ticket_img/buttons/Active-Minus.png');
}

.plusButton {
    background:url('https://www.ruth-musical.org/static/ticket_img/buttons/Enabled-Plus.png');
    margin-left:-2px !important;
}

.plusButton:disabled {
    background:url('https://www.ruth-musical.org/static/ticket_img/buttons/Disabled-Plus.png');
}

.plusButton:active {
    background:url('https://www.ruth-musical.org/static/ticket_img/buttons/Active-Plus.png');
}

.accordion > .frame > .heading, .accordion > .frame.active > .heading, .accordion > .frame.active > .heading, .accordion > .frame > .heading:hover {
    background-color:transparent;
    color: white;
    border:none;
    box-shadow:none;
    text-shadow:none;
    font-size:23px;
    text-transform:none;
    font-weight: bold;
    background: #f3dba8;
    margin-top:20px;
    margin-bottom:20px;
    color: #2d1e39;
}

.accordion > .frame > .heading > span {
    color: #2d1e39;
}

.accordion > .frame > .heading:before {
    content: ">";
    padding-left: 10px;
    font-weight:bold;
    border:none;
    transform:rotate(0deg);
}

.accordion > .frame.active > .heading:before {
    margin-left:20px;
    margin-top:5px;
    transform:rotate(90deg);
}

.accordion > .frame > .content {
    background-color:transparent;
    color: white;

    margin-top:-20px;
    padding-top:5px;
    border: 1px solid #f3dba8;
    border-top-color: transparent;
}

.accordion > .frame.soldout > .heading {
    background: none !important;
    background-image: url(https://www.ruth-musical.org/static/ticket_img/ticketheading.png) !important;
    -webkit-filter: grayscale(100%) !important;
    -moz-filter: grayscale(100%) !important;
    -o-filter: grayscale(100%) !important;
    -ms-filter: grayscale(100%) !important;
    filter: grayscale(100%) !important;
}

.smallcell {
    width:125px
}

.breadcrumb {
    width: 100%;
    margin-bottom: 30px;
}

.breadcrumb li a {
    color: #2d1e39;
    background: #f3dba8;
    font-size: 20px;
    font-weight: bold;
}

.breadcrumb li a.active {
    background: #FFF;
    color: #001e38;
}

.breadcrumb li a:after {
    border-left-color:#f3dba8;
}

.breadcrumb li a.active:after {
    border-left-color: #FFF;
}

.breadcrumb li a:before {
    border-left-color: #001e38;
}

#popup * {
    color: #FFF;
}

#popup {
    background-color: #310f74;
    border: 1px solid #f2a62c;
}

#popup>.heading {
    background: #f2a62c;
    color: #2d1e39;
}

.outerticketsbox>.heading {
    background: url(https://www.ruth-musical.org/static/ticket_img/ticketheading.png);
    color: #2d1e39;
    border:none;
}

.ticketsbox {
    border-color: #93763a;
}

#popup>.content>button {
    background-color: #2d1e39;
}

.nextButton, .nextButton:active {
    color: white;
    background-color: #bd2e26 !important;
}

.categorySoldOut {
    color: white !important;
}

</style>`;

    export default {
        name: 'Tickets',
        data: function () {
            return {
                displayLoading: true
            }
        },
        props: ['id'],
        components: {
            ruthHeader,
            socialMedia,
            ruthFooter,
            ruthOverlay,
            loader
        },
        mounted: function () {
            let app = this;

            $("#ticketframe").on('load', function() {
                let frame = document.getElementById('ticketframe');
                frame.contentWindow.postMessage(css, '*');
                window.setTimeout(function() {
                    frame.style.display = 'block';
                    app.displayLoading = false;
                }, 700)
            });

            // document.getElementById('ticketframe').src = "http://localhost:8080/" + this.id;
            document.getElementById('ticketframe').src = "https://ticket.kisi.org/" + this.id;
        }
    }

    function getUrlParameter(sParam) {
        let sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    }

    window.addEventListener('message', function(event) {
        if (~event.origin.indexOf('http://localhost') || event.origin.endsWith('kisi.org') || ~event.origin.indexOf('https://www.sternstunde.kisi.org')) {
            if (event.data === "scroll")
                $('html, body').animate({
                    scrollTop: $("iframe").offset().top - 100
                }, 500);
        } else {
            return;
        }
    });
</script>

<style lang="scss">
    @import "../assets/scss/var";

    .ticketbox {
        width: 100%;
        height: 1250px;
        background-color: rgba($color: $container_background_color, $alpha: 0.4);
        border-radius: 2px;

        @media screen and (max-width: 700px) {
            background-color: transparent;
        }
    }

    #ticketframe {
        border: none;
    }

    @keyframes load1 {
        0%,
        80%,
        100% {
            box-shadow: 0 0;
            height: 4em;
        }
        40% {
            box-shadow: 0 -2em;
            height: 5em;
        }
    }

    #container.nobackgroundimg {
        background: url("../assets/img/ticket-header.png") no-repeat $container_background_color;
        background-size: contain;
        padding-top: 100px;
    }

    #content h1.ticketsheading {
        font-size: 100px;
        z-index: 100000;
    }

    @media screen and (max-width: 1400px) {
        #container.nobackgroundimg {
            padding-top: 50px;
        }
    }

    @media screen and (max-width: 1000px) {
    }

    @media screen and (max-width: 900px) {}

    @media screen and (max-width: 700px) {
        #container.nobackgroundimg {
            background-size: 200%;
            background-position: top center;
        }
    }

    @media screen and (max-width: 450px) {}
</style>


// WEBPACK FOOTER //
// src/components/Tickets.vue